import type {
  ClassificationInventoryListingConfig,
  automotiveClassificationLabels,
  automotiveClassificationTypesLabels,
  automotiveClassificationTypesValues,
  automotiveClassificationValues
} from "@dealer-center/ddc-pages-inventory-config-interface";
import {
  automotiveClassificationGetValue,
  automotiveClassificationLabelsList,
  automotiveClassificationTypesGetValue,
  automotiveClassificationTypesLabelsList
} from "@dealer-center/ddc-pages-inventory-config-interface";
import type { baseInputs } from "./base";

type classificationTypesFlat = Record<
  classificationListType,
  classificationInputs
>;
export type classificationListType = keyof ClassificationInventoryListingConfig;
export interface classificationInputs extends baseInputs {
  type: "classification";
  options: {
    label: automotiveClassificationLabels;
    value: automotiveClassificationValues;
    options: {
      label: automotiveClassificationTypesLabels;
      value: automotiveClassificationTypesValues;
    }[];
  }[];
  default: number[];
}

const standardOptions = automotiveClassificationTypesLabelsList.map(type => {
  return { label: type, value: automotiveClassificationTypesGetValue(type) };
});

export const classificationTypeListFlat: classificationTypesFlat = {
  classificationTypes: {
    type: "classification",
    dataIndex: "classificationTypes",
    label: "Classification Type List",
    options: automotiveClassificationLabelsList.map(classification => {
      return {
        label: classification,
        value: automotiveClassificationGetValue(classification),
        options: standardOptions
      };
    }),
    default: []
  }
};

export const isClassification = (
  input: baseInputs
): input is classificationInputs => input.type === "classification";

// 1automotiveClassification: 5 is fleet used

// Type: 2automotiveClassification: 4
// Type: 2automotiveClassification: 6
// is primary new and exotic new

// <input type="checkbox" name="classification0" value="0" onclick="window['inventoryConfigBlockJS'].allClasses(this,'0');window['inventoryConfigBlockJS'].enableRadios('type0',!this.checked);"><b>All Classes</b><br>
//         &nbsp;&nbsp;<input type="radio" name="type0" value="0" disabled="">All Types
//         &nbsp;&nbsp;<input type="radio" name="type0" value="1" disabled="">Used
//         &nbsp;&nbsp;<input type="radio" name="type0" value="2" disabled="">New
// <input type="checkbox" name="classification4" value="4" onclick="window['inventoryConfigBlockJS'].enableRadios('type4',!this.checked);"><b>Primary</b><br>
//         &nbsp;&nbsp;<input type="radio" name="type4" value="0" disabled="">All Types
//         &nbsp;&nbsp;<input type="radio" name="type4" value="1" disabled="">Used
//         &nbsp;&nbsp;<input type="radio" name="type4" value="2" disabled="">New
// <input type="checkbox" name="classification5" value="5" onclick="window['inventoryConfigBlockJS'].enableRadios('type5',!this.checked);" checked=""><b>Fleet</b><br>
//         &nbsp;&nbsp;<input type="radio" name="type5" value="0">All Types
//         &nbsp;&nbsp;<input type="radio" name="type5" value="1" checked="">Used
//         &nbsp;&nbsp;<input type="radio" name="type5" value="2">New
// <input type="checkbox" name="classification7" value="7" onclick="window['inventoryConfigBlockJS'].enableRadios('type7',!this.checked);"><b>Wholesale</b><br>
//         &nbsp;&nbsp;<input type="radio" name="type7" value="0" disabled="">All Types
//         &nbsp;&nbsp;<input type="radio" name="type7" value="1" disabled="">Used
//         &nbsp;&nbsp;<input type="radio" name="type7" value="2" disabled="">New
// <input type="checkbox" name="classification6" value="6" onclick="window['inventoryConfigBlockJS'].enableRadios('type6',!this.checked);"><b>Exotic</b><br>
//         &nbsp;&nbsp;<input type="radio" name="type6" value="0" disabled="">All Types
//         &nbsp;&nbsp;<input type="radio" name="type6" value="1" disabled="">Used
//         &nbsp;&nbsp;<input type="radio" name="type6" value="2" disabled="">New
// <input type="checkbox" name="classification8" value="8" onclick="window['inventoryConfigBlockJS'].enableRadios('type8',!this.checked);"><b>Classifieds</b><br>
//         &nbsp;&nbsp;<input type="radio" name="type8" value="0" disabled="">All Types
//         &nbsp;&nbsp;<input type="radio" name="type8" value="1" disabled="">Used
//         &nbsp;&nbsp;<input type="radio" name="type8" value="2" disabled="">New
